<template>
  <div class="sitemap">
    <div class="container">
      <h1 class="sitemap__title">Карта сайта</h1>
      <VTabsMTS>
        <VTabMTS
          v-for="(section, idxSection) in sectionsList"
          :key="idxSection"
          :name="section.name"
          :selected="idxSection === 0"
          class="sitemap__content"
        >
          <template v-if="section.itemsList.length > 8">
            <div
              v-for="(column, colIdx) in chunkArray(section.itemsList, 8)"
              :key="colIdx"
              class="sitemap__content-column"
            >
              <ul class="sitemap__content-list">
                <li
                  v-for="(item, idxItem) in column"
                  :key="idxItem"
                  class="sitemap__content-list-item"
                >
                  <a :href="item.link">{{ item.name }}</a>
                </li>
              </ul>
            </div>
          </template>
          <template v-else>
            <ul class="sitemap__content-list">
              <li
                v-for="(item, idxItem) in section.itemsList"
                :key="idxItem"
                class="sitemap__content-list-item"
              >
                <a :href="item.link">{{ item.name }}</a>
              </li>
            </ul>
          </template>
        </VTabMTS>
      </VTabsMTS>
    </div>
  </div>
</template>
<script>
import VTabMTS from '~/components/Common/MTS/VTabMTS.vue'
import VTabsMTS from '~/components/Common/MTS/VTabsMTS.vue'
import SitemapMixin from '~/components/Page/Sitemap/mixins/SitemapMixin'
export default {
  name: 'SitemapDesktop',
  components: {
    VTabMTS,
    VTabsMTS,
  },
  mixins: [SitemapMixin],
  methods: {
    chunkArray(arr, size = 8) {
      const res = []
      for (let i = 0; i < arr.length; i += size) {
        res.push(arr.slice(i, i + size))
      }
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.sitemap {
  font-family: $font-mts-compact;
  color: $color-dark-2;
  padding: 64px 0 134px;

  @include screen-down('lg') {
    padding: 40px 0 159px;
  }

  .container {
    max-width: 1264px;

    @include screen-down('lg') {
      padding-left: 40px;
      padding-right: 40px;
    }
  }

  &__title {
    padding-bottom: 24px;
    font-size: 44px;
    font-weight: 500;
    line-height: 44px;
  }
  &__content {
    display: grid;
    @include screen-up('lg') {
      gap: 32px;
      grid-auto-flow: column;
      grid-template-columns: max-content;
    }

    &-list {
      list-style: none;
      margin: 0;
      position: relative;

      &-item {
        width: fit-content;
        padding-bottom: 12px;
        padding-right: 32px;
        a {
          font-size: 24px;
          line-height: 32px;
          font-weight: 400;
          text-decoration: underline;
          color: $color-gray-1;
        }
      }
    }
  }
}
</style>
